import React from 'react'

const SampleScreen = () => {
  return (
    <div class="sample"><p>Sample</p></div>
  )
}

export default SampleScreen